module.exports = __webpack_public_path__ + "static/media/activity-icon-ant.a3f63109.svg";